// extracted by mini-css-extract-plugin
module.exports = {"container":"namedPatient_container__3R_Mq","name":"namedPatient_name__1BtWN","avatar":"namedPatient_avatar__yjtOA"};